<script>
import {
  tableRows,
  groupByField,
  tableHeaders,
  getButtonTitle,
  passLink,
  additionalInfo,
} from '@/components/base-components/Packages/passes';
import {mapGetters, mapState} from 'vuex';
import {mapCacheActions} from 'vuex-cache';
import {GET_ORDERS, GET_PACKAGES, GET_SUBSCRIPTIONS} from '@/store/actionTypes';
import {ORDER_ACTIVITY_STATUS, ORDER_STATUS} from '@/const';
import {GET_PASSES_WITH_ACCESSES} from '@/store/getterTypes';
import AppLink from '@/components/base-components/AppLink.vue';

export default {
  name: 'PassTable',
  components: {AppLink},
  tableRows,
  tableHeaders,
  methods: {
    passLink,
    groupByField,
    ...mapCacheActions({
      getPackagesCached: GET_PACKAGES,
      getSubscriptionsCached: GET_SUBSCRIPTIONS,
      getOrders: GET_ORDERS,
    }),
    buttonText(pass) {
      return [getButtonTitle(pass, this.channelSettings.currency, this.isLogged)];
    },
  },
  computed: {
    additionalInfo() {
      return additionalInfo;
    },
    ...mapState({
      channelSettings: (state) => state.channel.settings,
    }),
    ...mapGetters({
      isLogged: 'isLogged',
      userPasses: GET_PASSES_WITH_ACCESSES,
    }),
    tableData() {
      return this.groupByField(this.userPasses, 'tag');
    },
  },
  watch: {
    isLogged() {
      this.isLogged && this.getOrders({
        status: ORDER_STATUS.paid,
        activity_status: ORDER_ACTIVITY_STATUS.active,
        no_limit: 1,
      });
    },
  },
  mounted() {
    this.getPackagesCached();
    this.getSubscriptionsCached();
    this.isLogged && this.getOrders({
      status: ORDER_STATUS.paid,
      activity_status: ORDER_ACTIVITY_STATUS.active,
      no_limit: 1,
    });
  },
};
</script>

<template>
  <div class="table_wrapper">
    <table>
      <thead>
        <tr v-for="header in $options.tableHeaders" :key="header.key">
          <th :class="header.className">{{ header.name }}</th>
          <th v-for="({data, colspan, id}) of header.callback(tableData)"
              :key="`${header.key}_${id}`"
              :colspan="colspan"
              class="no-border"
          >
            {{ data.text }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in $options.tableRows" :key="row.key">
          <td :data-title="row.name" v-html="row.name"/>
          <td
            v-for="({data, colspan, cellKey, styles}) of row.callback(tableData)"
            :key="`${row.key}_${cellKey}`"
            :colspan="colspan"
            :class="data.className"
            :style="row.needStyle? styles: {}"
          >
            <component v-if="data.component" :is="data.component"/>
            <div v-else-if="data.html" v-html="data.html"/>
            <template v-else>{{ data.text }}</template>
          </td>
        </tr>
        <tr>
          <td class="no-border">
            <div
              v-html="additionalInfo.logins.text"
              class="table_additional"
            />
          </td>
          <td
            v-for="pass in tableData"
            :key="`${pass.id}_${pass.passType}`"
            class="no-border buttons"
          >
            <div class="pass_actions">
                <app-link
                  v-for="btn in buttonText(pass)"
                  class="pass-table_button"
                  :to="passLink(pass, $route)"
                  :disabled="pass.purchased"
                  :style="{
                    backgroundColor: pass['package-button-background'],
                    color: pass['package-button-text-color'],
                  }"
                  :key="btn.title"
                  :title="btn.title"
                >
                  <div v-html="btn.html"/>
                </app-link>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped lang="scss">
.table_wrapper {
  max-width: 95vw;
  overflow-x: auto;
  display: flex;
}

table {
  font-style: normal;
  font-weight: normal;
  margin: 0 auto;

  thead{
    th {
      border-top-left-radius: .5rem;
      border-top-right-radius: .5rem;
    }
  }
  tbody {
    .flex-column-child {
      > * {
        display: flex;
        flex-direction: column;
      }
    }
    tr:first-child{
      font-weight: 600;
      td {
        border: none;
        border-top-left-radius: .5rem;
        border-top-right-radius: .5rem;
      }
    }
  }
  td:nth-child(n+2) {
    width: calc(25ch + 2rem);
    min-width: calc(25ch + 2rem);
  }

  td {
    height: 1rem;
    &.yes {
      color: var(--theme-link-accent);
    }
  }

  td, th {
    border: 1px solid var(--settings-body-text-color-30);
    padding: 1rem;

    &:first-child {
      white-space: nowrap;
      font-weight: 700;
    }
  }

  tr {
    td:first-child {
      text-align: left;
    }
  }

  .no-border {
    border: none;
  }
}
.buttons{
  padding: 0 0.05rem;
}
.pass_actions {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
}

.pass-table_button {
  padding: .5rem 1rem;
  width: 100%;
  border-radius: .3rem;
  color: var(--settings-buy-button-text-color);
  background: var(--settings-buy-button-background);
  font-weight: 400;
  transition: font-weight 0.2s linear;
  > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 2lh;

  }
  &:hover {
    color: var(--settings-buy-button-text-color);
    text-decoration: none;
    font-weight: 900;
  }
}
</style>
